// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Oo9U6","fixed":"Header_fixed__pKrtW","sticky":"Header_sticky__pB3wK"};